import { useTimelinePlayback } from "@/contexts/playback-context";
import { useViewSettings } from "@/view-settings";
import { useSelector } from "@legendapp/state/react";

export function TimelineLoader() {
  const timelinePlayback = useTimelinePlayback();
  const viewSettings = useViewSettings();
  const isPending = useSelector(
    () => timelinePlayback.playbackState.get() === "pending"
  );
  const context = useSelector(() =>
    timelinePlayback.playbackLoadingContext.get()
  );
  const viewMode = useSelector(() => viewSettings.viewMode.get());

  if (!isPending) return null;

  const text =
    context === "tracks-pending"
      ? "Tracks loading..."
      : context === "video-pending"
        ? "Video loading..."
        : "Loading...";

  const detectionsText =
    context === "detections-pending"
      ? "Detections loading..."
      : context === "reprojections-pending"
        ? "Reprojections loading..."
        : "Loading...";

  return (
    <div className="absolute pointer-events-none top-0 left-0 flex justify-end items-end w-full h-full z-[100] h-[194px]">
      <span className="m-4 bg-black pointer-events-auto rounded-full text-white px-4 text-sm py-1">
        {viewMode === "detections" ? detectionsText : text}
      </span>
    </div>
  );
}
